<template>
  <el-container>
    <div :class="`m-mobile .m-mobile-main ${currentModule} m-mobile-nav`">
      <!-- <img src="../../assets/mobile/bg.png" alt class="bgc" /> -->
      <div class="nav-list">
        <ul>
          <li @click="handleToReader">
            <div>
              <a href="javascript:;">
                <img src="../../assets/mobile/zz.png" />
                <p>致读者</p>
              </a>
            </div>
          </li>
          <li @click="handleMicNanPing">
            <div>
              <a href="javascript:;">
                <img src="../../assets/mobile/zw.png" />
                <p>微南平</p>
              </a>
            </div>
          </li>
          <li @click="handleReadZhuZi">
            <div>
              <a href="javascript:;">
                <img src="../../assets/mobile/zp.png" />
                <p>品朱子</p>
              </a>
            </div>
          </li>
          <li>
            <div>
              <a :href="$app.url.zzsc" target="_blank">
                <img src="../../assets/mobile/zg.png" />
                <p>购特色</p>
              </a>
            </div>
          </li>
        </ul>
      </div>
      <bs-detail
        :meta="{ module:'single-article',field:'copyright'}"
        ref="refId"
        :filter="{}"
        :is-loading="true"
      >
        <template slot="data" slot-scope="slot">
          <div class="copyright" v-html="slot.data.artContent"></div>
        </template>
      </bs-detail>
    </div>
  </el-container>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    }
  },
  components: {
    BsDetail: () => import("../../components/bs-detail")
  },
  methods: {
    handleToReader() {
      this.$router.push({
        path: "/mobile/new/main"
      });
    },
    handleMicNanPing() {
      this.$router.push({
        path: "/mobile/cult/main"
      });
    },
    handleReadZhuZi() {
      this.$router.push({
        path: "/mobile/arti/main"
      });
    },
    handleBuyFeature() {
      this.$router.push({
        path: "../mobile/research"
      });
    }
  },
  created() {
    this.$menuFn.setTitle("朱子文化大观");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "mobile-main") {
        this.$menuFn.setTitle("朱子文化大观");
      }
    }
  }
};
</script>

<style scoped="scoped">
* {
  margin: 0;
  padding: 0;
}
.m-mobile-nav {
  width: 100%;
  height: 100%;
  background: url("../../assets/mobile/bg.png") no-repeat;
  position: absolute;
  background-size: 100% 100%;
  /* padding-bottom: 50px; */
}
@media (max-height: 280px) {
  .m-mobile-nav {
    padding-bottom: 100px;
  }
}
@media (min-height: 280px) {
  .m-mobile-nav .bgc {
    height: 93%;
  }
}
@media (min-height: 1024px) {
  .m-mobile-nav .bgc {
    height: 100%;
  }
}
.m-mobile-nav .bgc {
  width: 100%;
  position: fixed;
}
/* 引导选项 */
.m-mobile-nav .nav-list {
}

@media screen and (min-height: 280px) and (max-width: 320px) {
  .m-mobile-nav {
    width: 100%;
    height: 100%;
    background: url("../../assets/mobile/bg.png") no-repeat;
    position: absolute;
    background-size: 100% 100%;
    /* padding-bottom: 50px; */
  }
}
.m-mobile-nav .title {
  font-size: 24px;
  font-weight: normal;
  position: absolute;
  top: 30%;
  color: rgba(104, 11, 11, 1);
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
@media screen and (min-height: 585px) and (max-height: 1024px) {
.m-mobile-nav .nav-list ul {
  width: 72%;
  position: absolute;
  left: 0;
  right: 0;
  padding-top: 58%;
  margin: auto;
}
}
@media screen and (min-height: 280px) and (max-height: 580px) {
.m-mobile-nav .nav-list ul {
  width: 72%;
  position: absolute;
  left: 0;
  right: 0;
  padding-top: 35%;
  margin: auto;
}
}
.m-mobile-nav .nav-list ul li {
  background-size: 100% 100%;
  width: 50%;
  height: 148px;
  float: left;
  list-style: none;
  text-align: center;
}
.m-mobile-nav .nav-list ul li div {
  text-align: center;
  padding-top: 30px;
}
.m-mobile-nav .nav-list ul li div a {
  border-radius: 6px;
  text-decoration: none;
  font-size: 16px;
  font-family: SourceHanSansCN-Normal;
  font-weight: bold;
  color: rgba(104, 11, 11, 1);
  line-height: 19px;
  text-align: center;
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
.m-mobile-nav .nav-list ul li div a img {
  width: 82%;
}
.m-mobile-nav .nav-list ul li div a p {
  margin: -16px;
}
.m-mobile-nav .copyright {
  width: 100%;
  text-align: center;
  background-color: #330000;
  position: fixed;
  bottom: 0;
  color: white;
  font-size: 12px;
  padding: 15px 0;
}
.m-mobile-nav .copyright p {
}
</style>
<style>
.m-mobile-nav .copyright p {
  padding: 0 10px;
  margin: 0;
}
</style>
